import React from 'react';
import "./HeroPage.css";
import Navbar from '../navbar/navbar';
import Heroinfo from '../heroinfo/heroinfo';
import Herobottom from '../herobottom/herobottom';

export default function HeroPage() {

    return (
        <div className='main'>
            <div className='heropagemain'>
                <img src="https://res.cloudinary.com/dqrwkgoi8/image/upload/v1706947670/rhpaqpkw8gpqdjfq84et.png" alt='background' id='background' />
                <div className='heropage'>
                    <Navbar />
                    <Heroinfo />
                    <Herobottom />
                </div>
            </div>
        </div>
    )
}
